"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_timeago_1 = __importDefault(require("react-timeago"));
const styled_components_1 = __importDefault(require("styled-components"));
const TimeAgoTD = styled_components_1.default.span `
  color: #565d66;
`;
// Rather than showing a continual counter like "0 seconds ago"
// followed by "1 seconds ago", and so on, just show "less than a minute"
const slowDownFormatter = (value, unit, suffix, epochMiliseconds, nextFormatter) => {
    if (unit === "second") {
        return "less than a minute";
    }
    // This should be defined but we'll play it safe given the type definition
    if (!nextFormatter) {
        return `${value} ${unit} ${suffix}`;
    }
    return nextFormatter(value, unit, suffix, epochMiliseconds);
};
TimeAgoTD.displayName = "TimeAgoTD";
class LastSaved extends React.PureComponent {
    render() {
        return (React.createElement(TimeAgoTD, null, this.props.lastModified != null && (React.createElement(react_timeago_1.default, { date: this.props.lastModified, formatter: slowDownFormatter }))));
    }
}
exports.LastSaved = LastSaved;
LastSaved.defaultProps = {
    lastModified: null
};
exports.default = LastSaved;
